module.exports = __webpack_public_path__ + "static/media/sermonSeriesImage.fe8e4a8d.jpg";